<template>
	<div class="contactStyle">
		<router-view></router-view>
	</div>
</template>

<script>
	export default {
		name: 'Contact'
	};
</script>
<style lang="scss" scoped>
	.contactStyle {
		font-family: 'PingFang SC', 'Microsoft YaHei', 'Helvetica Neue', Arial, sans-serif;
		color: #333;
		line-height: 1.6;
		background: linear-gradient(rgba(245, 250, 255, 0.92), rgba(245, 250, 255, 0.92)),
			url('../assets/images/背景1.jpg') center/cover no-repeat;
	}

	.section-title {
		font-size: 2rem;
		margin-bottom: 1.5rem;
		color: #2c3e50;
		text-align: center;
		position: relative;

		&::after {
			content: '';
			display: block;
			width: 80px;
			height: 3px;
			background: #3498db;
			margin: 1rem auto;
		}
	}

	.required {
		color: #e74c3c;
		margin-left: 4px;
	}

	.submit-button,
	.cta-button {
		background: #2c3e50;
		color: white;
		border: none;
		padding: 12px 24px;
		border-radius: 4px;
		font-size: 1rem;
		cursor: pointer;
		transition: all 0.3s ease;

		&:hover {
			background: darken(#2c3e50, 10%);
			transform: translateY(-2px);
		}

		&:disabled {
			background: #ecf0f1;
			cursor: not-allowed;
		}
	}

	/* // 顶部横幅 */
	.hero-banner {
		background: linear-gradient(135deg, #2c3e50 0%, #3498db 100%);
		color: white;
		padding: 80px 0 40px;
		text-align: center;
		position: relative;
		overflow: hidden;
		border-radius: 20px;

		.hero-title {
			font-size: 2.5rem;
			margin-bottom: 1rem;
			font-weight: 700;
		}

		.hero-subtitle {
			font-size: 1.2rem;
			margin-bottom: 2rem;
			opacity: 0.9;
		}

		.banner-tabs {
			display: flex;
			justify-content: center;
			margin-top: 2rem;

			.tab-button {
				background: transparent;
				color: white;
				border: none;
				padding: 12px 24px;
				font-size: 1rem;
				cursor: pointer;
				position: relative;
				opacity: 0.8;
				transition: all 0.3s ease;

				&.active {
					opacity: 1;
					font-weight: 600;

					&::after {
						content: '';
						position: absolute;
						bottom: 0;
						left: 50%;
						transform: translateX(-50%);
						width: 60%;
						height: 3px;
						background: white;
					}
				}

				&:hover {
					opacity: 1;
				}
			}
		}
	}
</style>